import React, { useMemo } from "react";
import { FormHelperText, FormControl } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { FormikProps } from "formik";
import dayjs, { Dayjs } from "dayjs";

export interface AbstractDateTimePickerProps {
    value?: number | null,
    label: string,
    name?: string,
    error?: string | React.ReactNode,
    submitHappen?: boolean,
    onChange?: (value: Dayjs | null) => void,
    formik?: FormikProps<any>,
    disabled?: boolean
}

export function DateTime({
                             name,
                             submitHappen,
                             formik,
                             value,
                             label,
                             error,
                             onChange,
                             disabled
                         }: AbstractDateTimePickerProps) {
    const id = useMemo(() => Math.random().toString(), []);

    if (formik && !name) {
        alert("name not defined, while formik defined");
    }

    const errorToDisplay = formik
        // @ts-ignore
        ? (submitHappen || formik.touched[name!]) && formik.errors[name!]
        : error;

    const valueCandidate = formik ? formik?.values[name!] : value;
    const fieldValue = useMemo(() => {
        return valueCandidate !== undefined ? dayjs(valueCandidate) : null
    }, [valueCandidate])


    return (
        <FormControl fullWidth>
            <DateTimePicker
                disabled={disabled}
                label={label}
                value={fieldValue}
                ampm={false}
                onChange={(newValue, a) => {
                    if(newValue && fieldValue === null) {
                        newValue = newValue.set("hour", 12)
                            .set("minute", 0)
                            .set("second", 0)
                            .set("millisecond", 0)
                    }
                    if (onChange) {
                        onChange(newValue);
                    } else if (formik && name) {
                        formik.setFieldValue(name, newValue ? newValue.unix() * 1000 : null);
                    }
                }}
                slotProps={{
                    textField: {
                        id,
                        name,
                        error: Boolean(errorToDisplay),
                    },
                }}
            />

            {errorToDisplay && (
                //@ts-ignore
                <FormHelperText error>{errorToDisplay}</FormHelperText>
            )}
        </FormControl>
    );
}